import { Theme } from '@glass/web/components/base/Theme';
import backdrop from '@glass/web/modules/theme/styles/backdrop';

type Response = {
  [key: string]: string | number;
};
const lightAppBar = (theme: Theme): Response => ({
  borderTop: '1px solid',
  position: 'fixed',
  top: 'auto',
  bottom: 0,
  left: 0,
  right: 0,
  borderColor: theme.palette.divider,
  padding: theme.spacing(1),
  zIndex: theme.zIndex.appBar,
  ...backdrop(theme, { opacity: 0.8, tintColor: '' }),
});

export default lightAppBar;
